import React from 'react';
import Page from './Page';
import AdminOnly from '../../components/AdminOnly';

function SensorOverviewContainer() {
  return (
    <AdminOnly>
      <Page />
    </AdminOnly>
  );
}

export default SensorOverviewContainer;
